// frontend/src/index.js
import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill/dist/quill.snow.css';
// Importar i18n antes que cualquier otro componente
import './i18n/i18n';

// Solo inicializar Sentry si hay un DSN configurado
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    sendDefaultPii: true
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Configuración de métricas - se envían automáticamente a través del metricsService
reportWebVitals();
